import React, { useEffect, useState } from "react";
import styles from "web/react/components/filter-redesign/menu-item-checkbox.module.css";
import SVGIcon from "web/react/components/svg-icon/svg-icon";

interface MenuItemCheckboxProps {
    label: string | React.ReactNode;
    to?: string;
    checked?: boolean;
    onChange?(checked: boolean): void;
}

export function MenuItemCheckbox({
    onChange,
    to,
    label,
    ...props
}: MenuItemCheckboxProps): JSX.Element {
    const [checked, setChecked] = useState<boolean>();

    useEffect(() => {
        setChecked(props.checked);
    }, [props.checked]);

    function onClick(e: React.MouseEvent): void {
        e.preventDefault();
        setChecked(!checked);
        onChange?.(!checked);
    }

    return (
        <a
            onClick={onClick}
            role="menuitemcheckbox"
            aria-checked={checked}
            className={styles.item}
            tabIndex={0}
            href={to}
        >
            {checked ? (
                <SVGIcon name="round-checkbox-checked" className={styles.icon} />
            ) : (
                <SVGIcon name="round-checkbox-bold" className={styles.icon} />
            )}
            <span className={styles.label}>{label}</span>
        </a>
    );
}
